import { Box, List, useTheme, InputBase, ButtonBase } from "@mui/material"
import SHModal from "../../theme/Modal/SHModal"
import Shbutton from "../../theme/buttons/Shbutton"
import { tokens } from "../../../theme";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import NumberInput from "../../theme/inputs/NumberInput";
import SelectGroup from "../../theme/Select/SelectGroup";
import { useState } from "react";
import ShValidatedNumberInput from "../../theme/inputs/ShValidatedNumberInput";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import AddIcon from '@mui/icons-material/Add';
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ShDropdownQuery } from "../../theme/dropdowns/Dropdown";
import { useGetUsersSelectQuery } from "../../../newapi/user/userSlice";
import cx from 'classnames';
import { formatPrice } from "../../../utils/helpers";
import { useGetInvoiceProductsSelectQuery } from "../../../newapi/financial/invoiceProductSlice";
import { useAddConceptInvoiceInvoiceProductMutation } from "../../../newapi/financial/invoiceSlice";
import { showToastMessage, showToastMessagePostRequest, showToastMessageRequestError } from "../../../utils/toasts";

const CustomMyComponent = (props) => {
    const {t, i18n} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <ButtonBase
            key={props.key}
            onClick={props.onClick}
            className={cx('',{
                'active': props.isSelected
            })}
            sx={{
                flexShrink:0,
                height:32,
                minWidth:300,
                width:1,
                pl:1.5,
                pr:0.5,
                textAlign:"left",
                display:"flex",
                justifyContent:'space-between',
                alignItems:"center",
                borderRadius:2,
                '&.active' : {
                    background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                    color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                    fontWeight:"900",
                }
            }}
        >
            {props.option.name}

            {props.option.cost && 
                <Box 
                    className={cx('',{
                        'active': props.isSelected
                    })}
                    sx={{
                        height:24,
                        background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                        display:"flex",
                        justifyContent:'center',
                        alignItems:"center",
                        px:1,
                        borderRadius:2,
                        '&.active' : {
                            background: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                            color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                            fontWeight:"900",
                        }
                    }}
                >
                    {formatPrice(i18n, props.option.cost)}
                </Box>
            }
        </ButtonBase>
    )
}


const MLinkCostToInbound = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();


    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const [value,setValue] = useState({
        id:-1,
        name: t("no_selection")
    });

    const [invoiceProductInfo, setInvoiceProductInfo] = useState({
        invoiceProductId: null,
        amount: 1
    })

    const handleChange = (key, value) => {
        setInvoiceProductInfo({
          ...invoiceProductInfo,
          [key]: value
        });
      };  

    // const handleKeyDown = (event) => {
    //     // if (event.key === 'Enter') {
    //     //     confirm();
    //     // }
    // };
    const [addConceptInvoiceInvoiceProduct, {isLoading: isLoadingAddConceptInvoiceInvoiceProduct}] = useAddConceptInvoiceInvoiceProductMutation();
    const confirm = async() => {
        try {
            if (isLoadingAddConceptInvoiceInvoiceProduct) {
                return;
            }
            let errors = [];
            if (!invoiceProductInfo.invoiceProductId) {
                errors.push(t("err_invoiceproduct_missing"));
            }

            if (invoiceProductInfo.amount <= 0) {
                errors.push(t("err_amount_cannot_be_zero"));
            }

            if (errors.length > 0) {
                showToastMessage("error", `${t("create_failed")}: ${errors.join(", ")}`);
                return;
            }

            const createBody = {
                relationId: props.relationId,
                productId: invoiceProductInfo.invoiceProductId,
                inboundId: props.inboundId,
                amount: invoiceProductInfo.amount
            };

            const data = await addConceptInvoiceInvoiceProduct(createBody).unwrap();
            showToastMessagePostRequest(t, data);
            setValue({
                id:-1,
                name: t("no_selection")
            });

            props.handleClose();
        } catch(err) {
            showToastMessageRequestError(t("create_failed"), t, err);
        }
    }
    

    return(
        <SHModal
            open={props.open}
            onClose={props.handleClose}
        >
            <Box
                sx={{

                        maxWidth:500,
                }}
            >
                <Box 
                    sx={{
                        textAlign:"center",
                        paddingY:4,
                        paddingX:5,
                        display:"flex",
                        flexDirection:"column",
                        gap:1,
                        // maxWidth:420,
                    }}>
                    <Subheading>{t("link_invoice_product")}</Subheading>
                </Box>
                <Box
                    sx={{
                        background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                        pt:2,
                        pb:1,
                        px:3,
                        borderTopLeftRadius:16,
                        borderTopRightRadius:16,
                        textAlign:"center",
                        // maxWidth:420,
                    }}
                >
                <ShDropdownQuery
                    name="name"
                    onChange={(selected,object) => {
                        handleChange("invoiceProductId", selected ? object.id : null);
                        setValue(
                            selected !== null ? object : {
                                id:-1,
                                name: t("no_selection")
                            }
                        );
                    }}
                    valueKey={"id"}
                    content={useGetInvoiceProductsSelectQuery}
                    config="inbound"
                    //dataKey={"data"} // for example with response : {success: true, data : selectData} we use data as datakey, in case of direct query just say null
                    shComponent={<CustomMyComponent/>}
                    selected={value.id}
                    closeOnSelection
                >
                    {({anchorEl,onClick}) => (
                        <ButtonBase
                            onClick={onClick}
                            sx={{
                                width:1,
                                mt:2,
                                height:40,
                                borderRadius:5,
                                background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                display:"flex",
                                alignItems:'center',
                                px:0.5,
                                position:'relative',
                                "&:before" : {
                                    content:'""',
                                    position:'absolute',
                                    borderRadius:5,
                                    left:0,
                                    top:0,
                                    width:1,
                                    height:1,
                                    background:  theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                    // border:`1px solid ${colors.grey[100]}`,
                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                }
                            }}
                        >

                            <Box
                                sx={{
                                    height:32,
                                    lineHeight:"32px",
                                    background: theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                    borderRadius:4,
                                    border: `1px solid ${ theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                    width:110,
                                    textAlign:"center",
                                    fontSize:14,
                                    fontWeight:"bold",
                                    color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                }}
                            >
                                {t("invoice_product")}

                            </Box>
                            <Box
                                sx={{
                                    flex:1,
                                    ml:1.5,
                                    textAlign:"left",
                                }}
                            >
                                <Text bold >
                                    {value.name}
                                </Text>
                            </Box>
                            <Box
                                sx={{
                                    display:'flex',
                                    gap:1.5,
                                    alignItems:'center',
                                }}
                            >
                                <Text italic bold variant={theme.palette.mode === "dark" ? "blue" :  "primary"}>
                                    {t("required")}
                                </Text>
                                <Box
                                    sx={{
                                        height:32,
                                        width:32,
                                        borderRadius:4,
                                        display:"flex",
                                        alignItems:'center',
                                        justifyContent:"center",
                                        background:theme.palette.mode === "dark" ? colors.blue[100] :  colors.primary[100],
                                        border: `1px solid ${theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                        color: theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                    }}
                                >
                                    <KeyboardArrowDownIcon/>

                                </Box>
                            </Box>

                        </ButtonBase>
                    )}
                </ShDropdownQuery>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:4,
                        marginTop: 2
                    }}
                >

                    <Box
                        sx={{
                            width:178,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text>{t("amount")}</Text>&nbsp;
                    </Box>
                    
                    <Box 
                        sx={{
                            display:"flex",
                            flex:1,
                        }}
                    >
                        <Box    
                            sx={{
                                flex:1,
                                borderRadius:4,
                                display:"flex",
                                gap: 1
                            }}
                        >
                            <ShValidatedNumberInput
                                min={0}
                                btnSize={"24"}
                                name="amount"
                                value={invoiceProductInfo?.amount}
                                onChange={handleChange}
                            />
                        </Box>
                        
                    </Box>
                </Box>
                </Box>
               
                <Box
                    component="footer"
                    sx={{
                        
                        display:"block",
                        width:1,
                        paddingBottom: isStandAlone ? "32px" : "16px",
                        display:"flex",
                        alignItems:"center",
                        paddingRight:3,
                        zIndex:1058,
                        position:"relative",
                        paddingTop:2,
                        background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        borderBottomLeftRadius:24,
                        borderBottomRightRadius:24,
                        justifyContent:"space-between",
                        "@media screen and (max-width: 47.9375em)" : {
                            paddingRight:0,
                        }
                    }}
                >
                    
                    <Shbutton isCancel={true} className={"always-visible"} onClick={props.handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                    <ButtonGroup version={2}>
                        <Shbutton 
                            className={"group-btn"} 
                            color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                            onClick={confirm} 
                            variant="contained"
                            isLoading={isLoadingAddConceptInvoiceInvoiceProduct}
                        >
                            {t("save")}
                        </Shbutton>
                    </ButtonGroup>
                </Box>
            </Box>
        </SHModal>
    )
}

export default MLinkCostToInbound;